import { BsCheck2Circle } from "react-icons/bs"

const serviceList = ['Antibody deficiencies.', 'Testing for complement deficiencie', 'Cellular (T cell defects.', 'A medical laboratory or clinical laboratory', 'Neutrophil disorders.', 'DNA testing may be done here', 'Complement deficiencies.', 'This encompasses several different sciences', 'Testing innate immunity', 'Analyzes whole blood specimens to perform', 'Make informed health care decisions']

const BlogDetailsServiceList = ({ blogData }) => {
  return (
    <>
      <div className="flex flex-col md:flex-row items-start gap-5">
        <div>
          <figure data-aos="zoom-in-up" data-aos-duration="700" className="sm:h-[350px] h-[250px] md:w-[420px] w-full rounded-3xl overflow-hidden"><img src={blogData?.feature?.image} alt="" className="h-full w-full object-cover object-center" /></figure>
        </div>

        <div className="flex flex-col gap-y-3">
          {
            blogData?.feature?.features?.map((service, index) => (
              <h1 data-aos="fade-up" data-aos-duration="700" className="flex gap-3 items-center text-gray-700"><span className="text-[#0BB6D9] text-2xl"><BsCheck2Circle /></span>{service}</h1>
            ))
          }
        </div>
      </div>
    </>
  )
}

export default BlogDetailsServiceList